import React from 'react'

const CustomModal = ({children, title, isOpenModal, onClose}) => {
  return (
   <>
    {
        isOpenModal &&
            <div className='custom__modal__overlay'>
               <div className='custom__modal__container'>
                <div className='custom__modal__header'>
                        <h4 className='custom__modal__title'>{title}</h4>
                        <span className='custom__modal__close-button' onClick={onClose}>
                            <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#FFFFFF" d="M6.50009 8.19707L10.4516 12.1485L12.1486 10.4515L8.19715 6.50001L12.1486 2.54854L10.4516 0.851486L6.50009 4.80296L2.54862 0.851486L0.851562 2.54854L4.80303 6.50001L0.851562 10.4515L2.54862 12.1485L6.50009 8.19707Z"/>
                            </svg>
                        </span>
                    </div>
                    <div className='custom__modal__content'>
                        {children}
                    </div>
               </div>
            </div>
    }
   </>
  )
}

export default CustomModal